import { useEffect, useState } from "react";
import "../../Css/Home/HomeVenue.css";
import "swiper/css";
import "swiper/css/pagination";
import venues_demo_image from "../../Images/venues/venues_demo_image.jpg";
import { Link } from "react-router-dom";
import { get } from "../../services/ApiRouting";
import SectionComp from "../SectionComp";
import { Swiper, SwiperSlide } from "swiper/react";
import { Grid, Pagination } from "swiper/modules";

const HomeVenue = () => {
  const [VenuesList, setVenuesList] = useState([]);
  console.log("VenuesList",VenuesList)
  const [loading, setLoading] = useState(true);
  const venuesListFetch = async () => {
    try {
      setLoading(true);
      const response = await get(`subcategories?category_id=1&page=0&limit=100`);
      setVenuesList(response?.data);
    } catch (error) {
      setVenuesList([]);  

      console.error("Error fetching data:", error);
    
    } finally { 
      setLoading(false);
    }
  };

  useEffect(() => {
    const dbounce = setTimeout(() => {
      venuesListFetch();
    }, 300);

    return () => clearTimeout(dbounce);
  }, []);

  return (
    <>
      <section className="home-venues-section-main-con section section-bg">
        <div className="container">
          <SectionComp
            title={"Venue Types to Match Every Celebration"}
            para={
              "Discover a variety of venue types — from lavish resorts to cozy banquet halls, all in one place."
            }
          />

          <div className="home-venues-section-details-main-con">
            {loading ? (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : VenuesList.length > 0 ? (
              <Swiper
                slidesPerView={1}
                grid={{
                  rows: 2,
                  fill: "row",
                }}
                spaceBetween={20}
                pagination={{
                  clickable: true,
                  dynamicBullets: true,
                }}
                breakpoints={{
                  640: {
                    slidesPerView: 2,
                    grid: {
                      rows: 2,
                    },
                  },
                  768: {
                    slidesPerView: 2,
                    grid: {
                      rows: 2,
                    },
                  },
                  1024: {
                    slidesPerView: 3,
                    grid: {
                      rows: 2,
                    },
                  },
                  1200: {
                    slidesPerView: 3,
                    grid: {
                      rows: 2,
                    },
                  },
                }}
                modules={[Grid, Pagination]}
                className="mySwiper"
              >
                {VenuesList &&
                  VenuesList?.map((elem) => {
                    const { name, short_description, slug, image } = elem;
                    return (
                      <SwiperSlide
                        key={elem.id}
                        className="d-flex justify-content-center"
                      >
                        <div className="home-venues-section-details-main-card-con">
                          <Link
                            to={`/vendors?category=venues&subcategory=${slug}`}
                          >
                            <div className="home-venues-section-details-image-con">
                              <img
                                src={image || venues_demo_image}
                                alt={name}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = venues_demo_image;
                                }}
                              />
                            </div>
                            <div className="home-venues-section-details-text-con">
                              <h3>{name}</h3>
                              <p>{short_description}</p>
                            </div>
                          </Link>
                        </div>
                      </SwiperSlide>
                    );
                  })}
              </Swiper>
            ) : (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <p>No categories available at the moment.</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeVenue;
